export const DEFAULT_LOW_STOCK_THRESHOLD = 5

export type StockLevel = 'out' | 'low' | 'ok'

export function normalizeLowStockThreshold(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n)) return DEFAULT_LOW_STOCK_THRESHOLD
  return Math.min(10_000, Math.max(0, Math.trunc(n)))
}

export function classifyStock(stockQuantity: number, threshold: number): StockLevel {
  const stock = Math.max(0, Math.trunc(stockQuantity))
  const limit = normalizeLowStockThreshold(threshold)
  if (stock <= 0) return 'out'
  if (stock <= limit) return 'low'
  return 'ok'
}

export function stockLevelLabel(level: StockLevel): string {
  if (level === 'out') return 'Out of stock'
  if (level === 'low') return 'Low stock'
  return 'In stock'
}
